import {handleActions} from 'redux-actions';
import {Map} from 'immutable';

import ActionTypes from './action-types';

export default handleActions(
    {
        [ActionTypes.FETCH_FOR_ORGANIZATION_SUCCESS]: (state, {payload}) =>
            state.merge(payload.roles.map(role => [role.roleId, role])),
    },
    Map(),
);
